import { __assign } from 'tslib';
import * as React from 'react';

var SvgCheckmark = function SvgCheckmark(props) {
  return React.createElement("svg", __assign({
    "data-name": "Icon - Tick",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 120 120"
  }, props), React.createElement("path", {
    fill: "none",
    d: "M0 0h120v120H0z"
  }), React.createElement("path", {
    "data-name": "Path 1407",
    d: "m94.101 45.345-6.683-6.893a4.7 4.7 0 0 0-3.4-1.452 4.86 4.86 0 0 0-3.283 1.452l-14.3 14.756-13.6 13.786-4.456 4.6-13.128-13.789a4.635 4.635 0 0 0-3.283-1.452 4.7 4.7 0 0 0-3.4 1.452l-6.683 6.893a4.871 4.871 0 0 0-1.405 3.266 5.229 5.229 0 0 0 1.405 3.509l23.327 24.069a4.271 4.271 0 0 0 3.4 1.45 3.675 3.675 0 0 0 3.283-1.45l14.3-14.756 13.364-13.667 14.3-14.756a5.228 5.228 0 0 0 1.405-3.506 4.038 4.038 0 0 0-1.163-3.512Z",
    fill: "rgba(0,0,0,0.3)"
  }), React.createElement("path", {
    "data-name": "Path 227",
    d: "m94.101 41.345-6.683-6.893a4.7 4.7 0 0 0-3.4-1.452 4.86 4.86 0 0 0-3.283 1.452l-14.3 14.756-13.6 13.786-4.456 4.6-13.128-13.789a4.635 4.635 0 0 0-3.283-1.452 4.7 4.7 0 0 0-3.4 1.452l-6.683 6.893a4.871 4.871 0 0 0-1.405 3.266 5.229 5.229 0 0 0 1.405 3.509l23.327 24.069a4.271 4.271 0 0 0 3.4 1.45 3.675 3.675 0 0 0 3.283-1.45l14.3-14.756 13.364-13.667 14.3-14.756a5.228 5.228 0 0 0 1.405-3.506 4.038 4.038 0 0 0-1.163-3.512Z",
    fill: "#afafaf"
  }), React.createElement("path", {
    "data-name": "Path 1216",
    d: "m94.101 36.134-6.683-6.893a4.7 4.7 0 0 0-3.4-1.452 4.86 4.86 0 0 0-3.283 1.452l-14.3 14.756-13.6 13.786-4.456 4.6-13.128-13.789a4.635 4.635 0 0 0-3.283-1.452 4.7 4.7 0 0 0-3.4 1.452l-6.683 6.893a4.871 4.871 0 0 0-1.405 3.266 5.229 5.229 0 0 0 1.405 3.509l23.327 24.069a4.271 4.271 0 0 0 3.4 1.45 3.675 3.675 0 0 0 3.283-1.45l14.3-14.756 13.364-13.667 14.3-14.756a5.228 5.228 0 0 0 1.405-3.506 4.038 4.038 0 0 0-1.163-3.512Z",
    fill: "#fff"
  }));
};

export { SvgCheckmark as default };